import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "not-editable";
const pathData = "M499 88q8 7 8 18 0 12-8 19L126 504q-8 8-19 8H27q-12 0-19.5-7.5T0 485v-80q0-10 8-18L382 8q7-8 18-8 12 0 19 8zm-56 18l-43-42-42 42 42 43zm-80 80l-43-42L64 405l43 43zm141 252q8 8 8 18 0 8-8 18-7 7-18 7t-18-7l-33-34-33 34q-7 7-18 7t-18-7q-8-10-8-18 0-10 8-18l33-33-33-34q-8-8-8-17 0-10 8-18t18-8 18 8l33 33 33-33q8-8 18-8t18 8 8 18q0 9-8 17l-33 34z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/not-editable";
export { pathData, ltr, accData };